/**
 * Enum for VoipA dd Order Type.
 * @readonly
 * @enum {String} VoipAddOrderTypeEnum
 *
 * agent, machine, mix, everyone, none
 */

const VoipAddOrderTypeEnum = {
  AGENT   : 'agent',
  MACHINE : 'machine',
  MIX     : 'mix',
  EVERYONE: 'everyone',
  NONE    : 'none'
}

export default VoipAddOrderTypeEnum
